export default __webpack_public_path__ + "static/media/logo.71f2a7a3.svg";